import styled from "styled-components";

interface DateInputContainerProps {
  $minWidth?: string;
}

export const DateInputContainer = styled.div<DateInputContainerProps>`
  ${(props) => props.$minWidth && `min-width:${props.$minWidth};`}
`;
